const possessionAndInstalmentTransformer = data => {
  const instalmentMap = data?.instalment?.reduce((acc, plan) => {
    if (plan?.type) {
      acc[plan.type] = plan
    }
    return acc
  }, {})
  return {
    ...data,
    instalmentMap,
    disableInstalmentType: !(data?.instalmentType?.length === 2), //checking if the array contains both type of payment plan only then it will not be disabled
  }
}

export default possessionAndInstalmentTransformer
